import { useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import { unregister } from "../../worker/registerServiceWorker";

export default function Logout() {
	const { logout } = useAuth();

	useEffect(() => {
		unregister();
		logout();
	}, [logout]);

	return <p>Logging out...</p>;
}
